module.exports = {
  path: '//order',
  oneoffOrder: {
    path: '/oneoff',
    get: true
  },
  order: {
    path: '/:id',
    get: true
  }
};
